// Fix for window.open() contexts: manually upgrade existing elements that weren't
// automatically upgraded when the custom element was defined.

let elementObserver = null;

const upgradeIfNeeded = (element) => {
  // Only upgrade if not already upgraded (check for custom element methods)
  if (typeof element.connectedCallback !== 'function') {
    customElements.upgrade(element);
  }
};

const upgradeExistingElements = () => {
  const elements = document.getElementsByTagName('react-component');
  Array.from(elements).forEach(upgradeIfNeeded);
};

// Wait for custom element to be defined, then upgrade existing elements
customElements.whenDefined('react-component').then(() => {
  // Upgrade any elements that exist when custom element is defined
  setTimeout(upgradeExistingElements, 0);

  // Watch for dynamically added elements in popup/SPA contexts
  const shouldObserve = window.opener !== null || document.getElementById('root') !== null;
  if (shouldObserve && document.body) {
    elementObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.tagName?.toLowerCase() === 'react-component'
          ) {
            upgradeIfNeeded(node);
          }
        });
      });
    });

    elementObserver.observe(document.body, { childList: true, subtree: true });

    // Cleanup on unload
    window.addEventListener('beforeunload', () => elementObserver?.disconnect());
  }
});

// Also upgrade when DOM is ready (handles case where DOM loads after custom element defined)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', upgradeExistingElements);
} else {
  upgradeExistingElements();
}
